var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 0 16 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2699 10.1006C12.265 10.4977 12.1026 10.8767 11.8183 11.1541C11.534 11.4315 11.1512 11.5846 10.7541 11.5797C10.3569 11.5748 9.97794 11.4124 9.70055 11.1281L6.56284 7.91256L3.34728 11.0503C3.063 11.3277 2.68018 11.4808 2.28302 11.4759C1.88586 11.471 1.50691 11.3086 1.22952 11.0243C0.952126 10.74 0.799024 10.3572 0.803891 9.96006C0.808758 9.5629 0.971195 9.18395 1.25547 8.90656L4.47103 5.76885L1.33332 2.55328C1.05593 2.26901 0.902831 1.88618 0.907698 1.48903C0.912565 1.09187 1.075 0.712914 1.35928 0.435523C1.64355 0.158132 2.02637 0.00503062 2.42353 0.00989757C2.82069 0.0147645 3.19964 0.177201 3.47703 0.461475L6.61474 3.67704L9.83031 0.539331C10.1146 0.26194 10.4974 0.108837 10.8946 0.113704C11.2917 0.118571 11.6707 0.28101 11.9481 0.565283C12.2255 0.849557 12.3786 1.23238 12.3737 1.62954C12.3688 2.02669 12.2064 2.40565 11.9221 2.68304L8.70655 5.82075L11.8443 9.03632C12.1216 9.32059 12.2748 9.70342 12.2699 10.1006Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusBlackIcon);
export default __webpack_public_path__ + "static/media/minusBlackIcon.0b2830fdb5a469d88740d655be9642bd.svg";
export { ForwardRef as ReactComponent };